"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemporalShiftAbilityHandler = exports.TemporalShiftActorAbilityFactory = exports.TemporalShiftAbilityArgs = void 0;
const __1 = require("../..");
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const MaxAttributeIncrease_1 = require("../../core/effects/core/MaxAttributeIncrease");
const AttributeType_1 = require("../../core/enums/AttributeType");
const Registries_1 = require("../../core/state/Registries");
const Settings_1 = require("../../Settings");
class TemporalShiftAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.TemporalShift;
        this.__typeName = "TemporalShift";
    }
}
exports.TemporalShiftAbilityArgs = TemporalShiftAbilityArgs;
let TemporalShiftActorAbilityFactory = class TemporalShiftActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("TemporalShift", "Self", 4);
    }
};
TemporalShiftActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("TemporalShift")
], TemporalShiftActorAbilityFactory);
exports.TemporalShiftActorAbilityFactory = TemporalShiftActorAbilityFactory;
let TemporalShiftAbilityHandler = class TemporalShiftAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyBuff({
            sequence,
            creatorId: ability.invokerId,
            targetId: ability.invokerId,
            effect: new __1.LinkedEffectsEffectArgs([
                new __1.HasteEffectArgs(1),
                new MaxAttributeIncrease_1.MaxAttributeIncreaseEffectArgs(AttributeType_1.AttributeType.AllDamageResistance, Settings_1.BASE_LEVEL_ADR * container.getLevel(ability.invokerId)),
            ], false),
            duration: Duration_1.Duration.Turns(4),
            onApplied: (sequence) => {
                sequence.push(new __1.InstantVfxStepArgs(new __1.ActorVfxLocationSelector(ability.invokerId, "chest"), "MagicBubble"));
            }
        });
    }
};
TemporalShiftAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.TemporalShift)
], TemporalShiftAbilityHandler);
exports.TemporalShiftAbilityHandler = TemporalShiftAbilityHandler;
